<template>
  <div class="nk-content-wrap">
    <div class="components-preview wide-md mx-auto">
      <div class="nk-block nk-block-lg">
        <div class="nk-block-head">
          <div class="nk-block-head-content">
            <h4 class="title nk-block-title">Settings</h4>
            <div class="nk-block-des">
              <p>Your account settings here.</p>
            </div>
          </div>
        </div>
        <div class="card card-bordered" style="border-radius: 1.2rem;">
          <div class="card-inner">
            <form action="#" class="nk-wizard nk-wizard-simple is-alter wizard clearfix" role="application" novalidate="novalidate">
              <div style="display: flex; margin-bottom: 2rem;">
                <a href="javascript:void(0)" :class="check_pos(1)" @click="set_page(1)" style="border-radius: 0.6rem;">
                  <span>Account</span>
                </a> &nbsp;&nbsp;&nbsp; <a href="javascript:void(0)" :class="check_pos(2)" @click="set_page(2)" style="border-radius: 0.6rem;">
                  <span>Integrations</span>
                </a> &nbsp;&nbsp;&nbsp; <a href="javascript:void(0)" :class="check_pos(3)" @click="set_page(3)" style="border-radius: 0.6rem;">
                  <span>Permissions & Access Control</span>
                </a> &nbsp;&nbsp;&nbsp; <a href="javascript:void(0)" :class="check_pos(4)" @click="set_page(4)" style="border-radius: 0.6rem;">
                  <span>Plan & Billing Management</span>
                </a> &nbsp;&nbsp;&nbsp; <a href="javascript:void(0)" :class="check_pos(5)" @click="set_page(5)" style="border-radius: 0.6rem;">
                  <span>Account Actions & Settings</span>
                </a>
              </div>
              <div class="content clearfix" v-if="page_no==1">
                <div class="nk-wizard-head title current">
                  <h5>Account</h5>
                </div>
                <form @submit.prevent="handleSubmit" class="nk-wizard-content body current" id="wizard-01-p-0" role="tabpanel" aria-labelledby="wizard-01-h-0" aria-hidden="false">
                  <div class="row gy-3">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="form-label" for="busienss_name">Business Name <span style="color: red;">(*)</span></label>
                        <div class="form-control-wrap">
                          <input type="text" data-msg="Required" v-model="busienss_name" class="form-control required" id="busienss_name" name="busienss_name" required="">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="form-label" for="busienss_phone">Business Phone <span style="color: red;">(*)</span></label>
                        <div class="form-control-wrap">
                          <input type="phone" data-msg="Required" v-model="busienss_phone" class="form-control required" id="busienss_phone" name="busienss_phone" required="">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="form-label" for="busienss_address">Address</label>
                        <div class="form-control-wrap">
                          <textarea class="form-control no-resize" v-model="busienss_address" id="busienss_address"></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="form-label" for="busienss_pincode">Postcode</label>
                        <div class="form-control-wrap">
                          <input type="text" data-msg="Required" v-model="busienss_pincode" data-msg-email="Wrong Email" class="form-control required email" id="busienss_pincode" name="busienss_pincode" required="">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="form-label" for="busienss_city">City</label>
                        <div class="form-control-wrap">
                          <input type="text" data-msg="Required" v-model="busienss_city" class="form-control required" id="busienss_city" name="busienss_city" required="">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="form-label" for="busienss_state">State</label>
                        <div class="form-control-wrap">
                          <input type="text" data-msg="Required" v-model="busienss_state" class="form-control required" id="busienss_state" name="busienss_state" required="">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="form-label" for="busienss_country">Country</label>
                        <div class="form-control-wrap">
                          <input type="text" data-msg="Required" v-model="busienss_country" class="form-control required" id="busienss_country" name="busienss_country" required="">
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="form-label" for="busienss_timezone">Business Timezone <span style="color: red;">(*)</span></label>
                        <div class="form-control-wrap">
                          <select v-model="busienss_timezone" class="form-control required" id="busienss_timezone">
                            <option value="Pacific/Midway">Pacific/Midway</option>
                            <option value="Pacific/Honolulu">Pacific/Honolulu</option>
                            <option value="America/Anchorage">America/Anchorage</option>
                            <option value="America/Los_Angeles">America/Los_Angeles</option>
                            <option value="America/Denver">America/Denver</option>
                            <option value="America/Chicago">America/Chicago</option>
                            <option value="America/New_York">America/New_York</option>
                            <option value="America/Toronto">America/Toronto</option>
                            <option value="America/Sao_Paulo">America/Sao_Paulo</option>
                            <option value="Atlantic/Azores">Atlantic/Azores</option>
                            <option value="Europe/London">Europe/London</option>
                            <option value="Europe/Paris">Europe/Paris</option>
                            <option value="Europe/Berlin">Europe/Berlin</option>
                            <option value="Europe/Moscow">Europe/Moscow</option>
                            <option value="Asia/Dubai">Asia/Dubai</option>
                            <option value="Asia/Kolkata">Asia/Kolkata</option>
                            <option value="Asia/Calcutta">Asia/Calcutta</option>
                            <option value="Asia/Kathmandu">Asia/Kathmandu</option>
                            <option value="Asia/Bangkok">Asia/Bangkok</option>
                            <option value="Asia/Shanghai">Asia/Shanghai</option>
                            <option value="Asia/Tokyo">Asia/Tokyo</option>
                            <option value="Australia/Sydney">Australia/Sydney</option>
                            <option value="Pacific/Auckland">Pacific/Auckland</option>
                            <option value="Pacific/Fiji">Pacific/Fiji</option>
                            <option value="UTC">UTC</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br>
                  <div :class="'alert alert-' + msgType + ' mb-xl-0'" role="alert" v-if="msgTxt && msgTxt.length > 0">
                    {{ msgTxt }}
                  </div>
                  <br>
                  <button type="submit" class="btn btn-lg btn-success" style="border-radius: 0.6rem;"> Update </button>
                </form>
              </div>
              <div class="content clearfix" v-if="page_no==2">
                <div class="nk-wizard-head title current">
                  <h5>Integrations</h5>
                </div>
                <div class="nk-wizard-content body current" id="wizard-01-p-0" role="tabpanel" aria-labelledby="wizard-01-h-0" aria-hidden="false">
                  <div style="text-align: left; width: 100%;">
                    <h6 style="width: 100%; text-align: left;">Calendar Integration</h6>
                    <p style="width: 100%; text-align: left;"> Avoid scheduling conflicts and ensure smooth planning by preventing double bookings effortlessly. </p>
                    <ul class="chat-list" style="width: 80%; margin-left: 5%; margin-top: 3rem; margin-bottom: 4rem;">
                      <li class="chat-item">
                        <div style="align-items: center; display: flex;">
                          <div class="chat-media" style="height: 2rem; width: 2rem;">
                            <img src="https://app.meetsplanner.com/images/cal1.png">
                          </div>
                          <div class="chat-info">
                            <div class="chat-from">
                              <div class="name">Google Calendar</div>
                            </div>
                          </div>
                          <a href="javascript:void(0);" v-if="check_celender(0)" @click="connectGoogleNow()" class="btn btn-success btn-sm" style="border-radius:10rem;">
                            <span>Connect</span>
                          </a>
                          <a href="javascript:void(0);" v-if="check_celender(1)" class="btn btn-light btn-sm" style="border-radius:10rem;">
                            <span>Connected</span>
                          </a>
                        </div>
                        <hr>
                      </li>
                      <li class="chat-item" style="margin-top: 1.5rem;">
                        <div style="align-items: center; display: flex;">
                          <div class="chat-media" style="height: 2rem; width: 2rem;">
                            <img src="https://app.meetsplanner.com/images/cal2.png">
                          </div>
                          <div class="chat-info">
                            <div class="chat-from">
                              <div class="name">Microsoft Calendar</div>
                            </div>
                          </div>
                          <a href="javascript:void(0);" class="btn btn-success btn-sm" style="border-radius:10rem;">
                            <span>Connect</span>
                          </a>
                        </div>
                        <hr>
                      </li>
                      <li class="chat-item" style="margin-top: 1.5rem;">
                        <div style="align-items: center; display: flex;">
                          <div class="chat-media" style="height: 2rem; width: 2rem;">
                            <img src="https://app.meetsplanner.com/images/cal3.png">
                          </div>
                          <div class="chat-info">
                            <div class="chat-from">
                              <div class="name">Apple Calendar</div>
                            </div>
                          </div>
                          <a href="javascript:void(0);" class="btn btn-success btn-sm" style="border-radius:10rem;">
                            <span>Connect</span>
                          </a>
                        </div>
                        <hr>
                      </li>
                    </ul>
                  </div>
                  <div style="text-align: left; width: 100%;">
                    <h6 style="width: 100%; text-align: left;">Meeting Integration</h6>
                    <p style="width: 100%; text-align: left;"> Seamlessly connect and synchronize meetings across platforms for efficient scheduling and collaboration. </p>
                    <ul class="chat-list" style="width: 80%; margin-left: 5%; margin-top: 3rem; margin-bottom: 4rem;">
                      <li class="chat-item">
                        <div style="align-items: center; display: flex;">
                          <div class="chat-media" style="height: 2rem; width: 2rem;">
                            <img src="https://app.meetsplanner.com/images/google_meet.png">
                          </div>
                          <div class="chat-info">
                            <div class="chat-from">
                              <div class="name">Google Meet</div>
                            </div>
                          </div>
                          <a href="javascript:void(0);" v-if="check_celender(0)" @click="connectGoogleNow()" class="btn btn-success btn-sm" style="border-radius:10rem;">
                            <span>Connect</span>
                          </a>
                          <a href="javascript:void(0);" v-if="check_celender(1)" class="btn btn-light btn-sm" style="border-radius:10rem;">
                            <span>Connected</span>
                          </a>
                        </div>
                        <hr>
                      </li>
                      <li class="chat-item" style="margin-top: 1.5rem;">
                        <div style="align-items: center; display: flex;">
                          <div class="chat-media" style="height: 2rem; width: 2rem;">
                            <img src="https://app.meetsplanner.com/images/micro_team.png">
                          </div>
                          <div class="chat-info">
                            <div class="chat-from">
                              <div class="name">Microsoft Teams</div>
                            </div>
                          </div>
                          <a href="javascript:void(0);" class="btn btn-success btn-sm" style="border-radius:10rem;">
                            <span>Connect</span>
                          </a>
                        </div>
                        <hr>
                      </li>
                      <li class="chat-item" style="margin-top: 1.5rem;">
                        <div style="align-items: center; display: flex;">
                          <div class="chat-media" style="height: 2rem; width: 2rem;">
                            <img src="https://app.meetsplanner.com/images/zoom_lgo.png">
                          </div>
                          <div class="chat-info">
                            <div class="chat-from">
                              <div class="name">Zoom Meetings</div>
                            </div>
                          </div>
                          <a href="javascript:void(0);" class="btn btn-success btn-sm" style="border-radius:10rem;">
                            <span>Connect</span>
                          </a>
                        </div>
                        <hr>
                      </li>
                    </ul>
                  </div>
                  <div style="text-align: left; width: 100%;">
                    <h6 style="width: 100%; text-align: left;">Connect your gateways</h6>
                    <p style="width: 100%; text-align: left;"> Seamlessly integrate and connect your payment gateways for secure and efficient transactions. </p>
                    <ul class="chat-list" style="width: 80%; margin-left: 5%; margin-top: 3rem; margin-bottom: 4rem;">
                      <li class="chat-item">
                        <div style="align-items: center; display: flex;">
                          <div class="chat-media" style="height:2.5rem; width:2.7rem; align-items: center; text-align: center; background-color: #635bff; border-color: #635bff; border-radius: .5rem;">
                            <i class="fa-brands fa-cc-mastercard" style="font-size: 1.2rem; margin-top: .6rem; color: #fff;"></i>
                          </div>
                          <div class="chat-info">
                            <div class="chat-from">
                              <div class="name">Netivia</div>
                            </div>
                          </div>
                          <a href="javascript:void(0);" class="btn btn-success btn-sm" style="border-radius:10rem;">
                            <span>Connect</span>
                          </a>
                        </div>
                        <hr>
                      </li>
                      <li class="chat-item" style="margin-top: 1.5rem;">
                        <div style="align-items: center; display: flex;">
                          <div class="chat-media" style="height: 2rem; width: 2rem;">
                            <img src="https://app.meetsplanner.com/images/paypal.png">
                          </div>
                          <div class="chat-info">
                            <div class="chat-from">
                              <div class="name">Paypal</div>
                            </div>
                          </div>
                          <a href="javascript:void(0);" class="btn btn-success btn-sm" style="border-radius:10rem;">
                            <span>Connect</span>
                          </a>
                        </div>
                        <hr>
                      </li>
                    
                    </ul>
                  </div>
                </div>
              </div>
              <div class="content clearfix" v-if="page_no==3">
                <div style="text-align: left; width: 100%;">
                  <h5>Permissions & Access Control</h5>
                  <p style="width:100%;text-align:left;"> Manage user roles, access levels, and security settings to ensure controlled and secure system usage. </p>
                  <div style="margin-left:3%; margin-bottom:2rem; margin-top:2rem;">
                    <!-- User Roles & Access Levels -->
                    <h6>
                      <b>User Roles & Access Levels</b>
                    </h6>
                    <div class="custom-control custom-checkbox" style="margin-top:1rem;">
                      <input type="checkbox" id="chk1" v-model="chk1" @click="set_checked(1)" class="custom-control-input" value="Admin">
                      <label class="custom-control-label" for="roleAdmin" @click="set_checked(1)">
                        <strong>Admin (Full access to everything, including team management)</strong>
                      </label>
                    </div>
                    <br>
                    <div class="custom-control custom-checkbox" style="margin-top:1rem;">
                      <input type="checkbox" id="chk2" v-model="chk2" @click="set_checked(2)" class="custom-control-input" value="Manager">
                      <label class="custom-control-label" for="roleManager" @click="set_checked(2)">
                        <strong>Manager (Can edit and manage meetings but not user roles)</strong>
                      </label>
                    </div>
                    <br>
                    <div class="custom-control custom-checkbox" style="margin-top:1rem;">
                      <input type="checkbox" id="chk3" v-model="chk3" @click="set_checked(3)" class="custom-control-input" value="Employee">
                      <label class="custom-control-label" for="roleEmployee" @click="set_checked(3)">
                        <strong>Employee (Can view meetings but has limited access to settings)</strong>
                      </label>
                    </div>
                    <br>
                    <div class="custom-control custom-checkbox" style="margin-top:1rem;">
                      <input type="checkbox" id="chk4" v-model="chk4" @click="set_checked(4)" class="custom-control-input" value="Guest">
                      <label class="custom-control-label" for="roleGuest" @click="set_checked(4)">
                        <strong>Guest (Can only view specific meetings)</strong>
                      </label>
                    </div>
                    <br>
                    <br>
                    <br>
                    <!-- Invite Team Members -->
                    <h6>
                      <b>Invite Team Members</b>
                    </h6>
                    <div class="custom-control custom-checkbox" style="margin-top:1rem;">
                      <input type="checkbox" class="custom-control-input" id="sendInvite" value="Send an invite via email">
                      <label class="custom-control-label" for="sendInvite">
                        <strong>Send an invite via email</strong>
                      </label>
                      
                    </div>
                    <br><br>
                    <div class="form-control-wrap">
                        <input type="text" v-model="support_email" @change="set_support()" placeholder="Enter Mail Ids" class="form-control" required>
                      </div>
                    <br>
                    <br>
                    <br>
                    <!-- Permission Controls -->
                    <h6>
                      <b>Permission Controls (Decide What They Can See/Edit)</b>
                    </h6>
                    <div class="custom-control custom-checkbox" style="margin-top:1rem;">
                      <input type="checkbox" id="chk5" v-model="chk5" @click="set_checked(5)" class="custom-control-input" value="Meeting Access">
                      <label class="custom-control-label" for="permMeeting" @click="set_checked(5)">
                        <strong>Meeting Access (View, Edit, Delete)</strong>
                      </label>
                    </div>
                    <br>
                    <div class="custom-control custom-checkbox" style="margin-top:1rem;">
                      <input type="checkbox" id="chk6" v-model="chk6" @click="set_checked(6)" class="custom-control-input" value="Scheduling Access">
                      <label class="custom-control-label" for="permSchedule" @click="set_checked(6)">
                        <strong>Scheduling Access (Can create/edit meetings)</strong>
                      </label>
                    </div>
                    <br>
                    <div class="custom-control custom-checkbox" style="margin-top:1rem;">
                      <input type="checkbox" id="chk7" v-model="chk7" @click="set_checked(7)" class="custom-control-input" value="Transcription Access">
                      <label class="custom-control-label" for="permTranscription" @click="set_checked(7)">
                        <strong>Transcription Access (View/download transcripts)</strong>
                      </label>
                    </div>
                    <br>
                    <div class="custom-control custom-checkbox" style="margin-top:1rem;">
                      <input type="checkbox" id="chk8" v-model="chk8" @click="set_checked(8)" class="custom-control-input" value="Payment Settings Access">
                      <label class="custom-control-label" for="permPayment" @click="set_checked(8)">
                        <strong>Payment Settings Access (Access billing, invoices, and payments)</strong>
                      </label>
                    </div>
                    <br>
                    <div class="custom-control custom-checkbox" style="margin-top:1rem;">
                      <input type="checkbox" id="chk9" v-model="chk9" @click="set_checked(9)" class="custom-control-input" value="Integrations Access">
                      <label class="custom-control-label" for="permIntegrations" @click="set_checked(9)">
                        <strong>Integrations Access (Manage Google, Outlook, Zoom, Stripe, etc.)</strong>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content clearfix" v-if="page_no==4">
                <div style="text-align: left; width: 100%;">
                  <h5>Plan & Billing Management</h5>
                  <p style="width:100%;text-align:left;"> Manage plans, subscriptions, billing cycles, payments, and invoices with seamless automation and tracking. </p>
                  <div class="nk-block">
                    <div class="row g-gs">
                      <div class="col-md-4"  v-for="user in plans" :key="user">
                        <div class="price-plan card card-bordered text-center">
                          <div class="card-inner">
                            <div class="price-plan-media">
                              <img v-if="user.plan_img==null || apiBaseUrl==null || apiBaseUrl==undefined" :src="base_url+'images/icons/plan-s1.svg'" alt="">
                              <img v-if="user.plan_img!=null && apiBaseUrl!=null && apiBaseUrl!=undefined" :src="base_url+'images/icons/plan-s1.svg'" alt="">
                            </div>
                            <div class="price-plan-info">
                              <h5 class="title">{{user.plan_title}}</h5>
                              <span>{{user.plan_desc}}</span>
                            </div>
                            <ul>
                              <li  v-for="user1 in user.frt" :key="user1" style="margin-bottom: .5rem;">{{ user1.title }}</li>
                          </ul>
                          <br>
                            <div class="price-plan-amount">
                              <div class="amount">${{user.plan_price}} <span v-if="user.plan_type==='Month'">/mo</span> <span v-if="user.plan_type!=='Month'">/yr</span>
                              </div>
                              <span class="bill" v-if="user.plan_type==='Month'">1 User, Billed Monthly</span>
                              <span class="bill" v-if="user.plan_type!=='Month'">1 User, Billed Yearly</span>
                            </div>
                            <div class="price-plan-action" v-if="user.plan_id!=ldata.user_plan_id">
                              <a href="javascript:void(0)" @click="purPlanNow(user)" class="btn btn-success" style="border-radius: .6rem;">Select Plan</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="content clearfix" v-if="page_no==5">
                <div style="text-align: left; width: 100%;">
                  <h5>Account Actions & Settings</h5>
                  <p style="width:100%;text-align:left;"> Manage your account settings, security, preferences, and data retention for a seamless user experience. </p>
                  <div class="nk-block">
                   
                    <div class="support-topic-item card card-bordered">
                      <a class="support-topic-block card-inner" href="/change_password">
                        <div class="support-topic-media">
                          <i class="fa-solid fa-lock" style="font-size: 2.3rem;"></i>
                        </div>
                        <div class="support-topic-context">
                          <h5 class="support-topic-title title">Password & Security</h5>
                          <div class="support-topic-info">Change your password and enable Two-Factor Authentication (2FA) for extra security.</div>
                        </div>
                        <div class="support-topic-action">
                          <em class="icon ni ni-chevron-right"></em>
                        </div>
                      </a>
                    </div>
                    
                    <div class="support-topic-item card card-bordered">
                      <a class="support-topic-block card-inner" href="javascript:void();">
                        <div class="support-topic-media">
                          <i class="fa-solid fa-key" style="font-size: 2.3rem;"></i>
                        </div>
                        <div class="support-topic-context">
                          <h5 class="support-topic-title title">Authentication & API</h5>
                          <div class="support-topic-info">Manage API keys, OAuth settings, and authentication options.</div>
                        </div>
                        <div class="support-topic-action">
                          <em class="icon ni ni-chevron-right"></em>
                        </div>
                      </a>
                    </div>
                   
                    <!-- <div class="support-topic-item card card-bordered">
                      <a class="support-topic-block card-inner" href="javascript:void();">
                        <div class="support-topic-media">
                          <i class="fa-solid fa-cog" style="font-size: 2.3rem;"></i>
                        </div>
                        <div class="support-topic-context">
                          <h5 class="support-topic-title title">Preferences</h5>
                          <div class="support-topic-info">Adjust notification settings, language, and timezone preferences.</div>
                        </div>
                        <div class="support-topic-action">
                          <em class="icon ni ni-chevron-right"></em>
                        </div>
                      </a>
                    </div> -->
                    <div class="support-topic-item card card-bordered">
                      <a class="support-topic-block card-inner" href="javascript:void();" @click="close_acc()">
                        <div class="support-topic-media">
                          <i class="fa-solid fa-user-slash" style="font-size: 2.3rem; color:red;"></i>
                        </div>
                        <div class="support-topic-context">
                          <h5 class="support-topic-title title">Delete Account</h5>
                          <div class="support-topic-info">Permanently delete your account with confirmation.</div>
                        </div>
                        <div class="support-topic-action">
                          <em class="icon ni ni-chevron-right"></em>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button style="display: none;" id="delBt45" data-bs-toggle="modal"
    data-bs-target="#delForm" ></button>
    <div class="modal fade" id="delForm">
      <div class="modal-dialog" role="document">
          <div class="modal-content" style="border-radius:1rem;">
              <div class="modal-header">
                  <h6 class="modal-title">Terminate Account</h6>
              </div>
              <div class="modal-body">
                  <div class="form-validate is-alter">
                    <p>You will use all of your data account will not recover?</p>
                      <div class="form-group">
                          <button type="button" @click="del_item()" class="btn btn-danger" style="border-radius: 0.6rem;">
                              Yes
                          </button>
                          &nbsp;&nbsp;&nbsp;
                          <button id="btclose45" type="button" data-bs-dismiss="modal"
                          aria-label="Close" class="btn btn-outline-danger" style="border-radius: 0.6rem;">
                              No
                          </button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>
<script>
  import {
    mainBaseUrl,
    apiBaseUrl
  } from '@/apis/appconst';
  import {
    getMyDt,
    addBuss,
    upAccess,
    delAcc,
    upSupEmail,
    purPlan
  } from '@/apis/webapis';
  import { getPlanList1 } from '@/apis/memplanapis';
  export default {
    name: 'AppSettings',
    methods: {
      async getListNow() {
                const response = await getPlanList1("1","10","Month");
                if (response.status) {
                  this.plans = response.records;
                  for(var x=0;x<this.plans.length;x++){
                    var tmp = this.plans[x];
                    tmp.frt = JSON.parse(tmp.plan_features+"");

                    this.plans[x] = tmp;
                  }
                }
        },
      set_page($pos) {
        // alert(this.page_no+"");
        this.page_no = $pos;
        if(this.page_no==3){
          this.setup_perm();
        }
      },
      check_pos($pos) {
        if (this.page_no == $pos) {
          return "btn btn-success";
        }
        return "btn btn-secondary";
      },
      close_acc(){
        document.getElementById("delBt45").click();
      },
      setup_perm(){
        // alert(JSON.stringify(this.user_access));
        if (this.user_access.includes("Admin")) {
              this.chk1 = true;
            } if (this.user_access.includes("Manager")) {
              this.chk2 = true;
            } if (this.user_access.includes("Employee")) {
              this.chk3 = true;
            } if (this.user_access.includes("Guest")) {
              this.chk4 = true;
            } if (this.user_access.includes("Meeting")) {
              this.chk5 = true;
            } if (this.user_access.includes("Scheduling")) {
              this.chk6 = true;
            } if (this.user_access.includes("Transcription")) {
              this.chk7 = true;
            } if (this.user_access.includes("Payment")) {
              this.chk8 = true;
            } if (this.user_access.includes("Integrations")) {
              this.chk9 = true;
            }
      },
      check_celender(rtype){
          if(this.ldata.google_refresh_token!=undefined && this.ldata.google_refresh_token!=null){
            if(rtype==1){
              if((this.ldata.google_refresh_token+"").length>0){
                return true;
              }
            }
            else{
              if((this.ldata.google_refresh_token+"").length<=0){
                return true;
              }
            }
          }
          else if(rtype==0){
            return true;
          }
          return false;
        },
      async getMyCall() {
        this.msgType = "";
        this.msgTxt = "";
        const response = await getMyDt(this.ldata.user_id);
        if (response.status) {
          this.ldata = response.user;
          if (this.ldata.user_access != null && this.ldata.user_access.length > 0) {
            this.user_access = JSON.parse(this.ldata.user_access);
           this.setup_perm();
          }
          sessionStorage.setItem('ldata', JSON.stringify(response.user));
          this.myDt = response.buss_dt;
          this.support_email = this.myDt.support_email;
          this.busienss_id = this.myDt.busienss_id;
          this.busienss_user = this.myDt.busienss_user;
          this.busienss_name = this.myDt.busienss_name;
          this.busienss_phone = this.myDt.busienss_phone;
          this.busienss_address = this.myDt.busienss_address;
          this.busienss_pincode = this.myDt.busienss_pincode;
          this.busienss_city = this.myDt.busienss_city;
          this.busienss_state = this.myDt.busienss_state;
          this.busienss_country = this.myDt.busienss_country;
          this.busienss_timezone = this.myDt.busienss_timezone;
        }
      },
      async purPlanNow(plan_dt){
        const today = new Date();

        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
        const yyyy = today.getFullYear();

        const currentDate = `${dd}-${mm}-${yyyy}`;

        const response = await purPlan(
          plan_dt.plan_id,
          plan_dt.plan_title, 
          plan_dt.plan_price, 
          plan_dt.plan_duration, 
          currentDate, 
          "1", "1", 
          this.ldata.user_id
        );
        alert(response.message+"");
          if (response.status) {
           
            this.getMyCall();

          }
      },
      connectGoogleNow() {
          const url = apiBaseUrl+"google/connect/google?user_id="+this.ldata.user_id; // Backend Express route
          const popup = window.open(url, "popupWindow", "width=600,height=600");

          if (!popup) {
            alert("Popup blocked! Please allow popups.");
            return;
          }

          // Listen for message from popup
          window.addEventListener("message", (event) => {
            console.log("sdas",event);
            this.getMyCall();
        }, false);
      },
      async del_item() {
        this.msgType = "";
        this.msgTxt = "";
        const response = await delAcc(this.ldata.user_id);
        if (response.status) {
          sessionStorage.removeItem("ldata");
          window.location.href = "/";
          window.location.reload();
        }
      },
      valField1(field, msg) {
        if (field.length > 0) {
          return true;
        } else {
          this.msgType = "danger";
          this.msgTxt = msg;
          return false;
        }
      },
      async handleSubmit() {
        if (this.valField1(this.busienss_name, 'Enter Business Name') &&
         this.valField1(this.busienss_phone, 'Enter Phone Number') &&
              this.valField1(this.busienss_timezone, 'Select Timezone')) {
          this.msgType = "warning";
          this.msgTxt = "Loading...";
          const response = await addBuss(this.busienss_id, this.busienss_user, this.busienss_name, this.busienss_phone, this.busienss_address, this.busienss_pincode, this.busienss_city, this.busienss_state, this.busienss_country, this.busienss_timezone);
          if (response.status) {
            this.msgType = "success";
            this.msgTxt = response.message;
          } else {
            this.msgType = "danger";
            this.msgTxt = response.message;
          }
        }
      },
      async updateAccess() {
        await upAccess(this.ldata.user_id, JSON.stringify(this.user_access));
        //  if (response.status) {
        //     getMyDt();
        //  }
      },
      async set_support(){
        if(this.support_email.length>0){
          await upSupEmail(this.ldata.user_id, this.support_email);
        }
      },
      set_checked($pos) {
        switch ($pos) {
          case 1:
            if (this.chk1) {
              this.chk1 = false;
              let index = this.user_access.indexOf("Admin");
              if (index !== -1) {
                this.user_access.splice(index, 1);
              }
            } else {
              this.chk1 = true;
              this.user_access.push("Admin");
            }
            break;
          case 2:
            if (this.chk2) {
              this.chk2 = false;
              let index = this.user_access.indexOf("Manager");
              if (index !== -1) {
                this.user_access.splice(index, 1);
              }
            } else {
              this.chk2 = true;
              this.user_access.push("Manager");
            }
            break;
          case 3:
            if (this.chk3) {
              this.chk3 = false;
              let index = this.user_access.indexOf("Employee");
              if (index !== -1) {
                this.user_access.splice(index, 1);
              }
            } else {
              this.chk3 = true;
              this.user_access.push("Employee");
            }
            break;
          case 4:
            if (this.chk4) {
              this.chk4 = false;
              let index = this.user_access.indexOf("Guest");
              if (index !== -1) {
                this.user_access.splice(index, 1);
              }
            } else {
              this.chk4 = true;
              this.user_access.push("Guest");
            }
            break;
          case 5:
            if (this.chk5) {
              this.chk5 = false;
              let index = this.user_access.indexOf("Meeting");
              if (index !== -1) {
                this.user_access.splice(index, 1);
              }
            } else {
              this.chk5 = true;
              this.user_access.push("Meeting");
            }
            break;
          case 6:
            if (this.chk6) {
              this.chk6 = false;
              let index = this.user_access.indexOf("Scheduling");
              if (index !== -1) {
                this.user_access.splice(index, 1);
              }
            } else {
              this.chk6 = true;
              this.user_access.push("Scheduling");
            }
            break;
          case 7:
            if (this.chk7) {
              this.chk7 = false;
              let index = this.user_access.indexOf("Transcription");
              if (index !== -1) {
                this.user_access.splice(index, 1);
              }
            } else {
              this.chk7 = true;
              this.user_access.push("Transcription");
            }
            break;
          case 8:
            if (this.chk8) {
              this.chk8 = false;
              let index = this.user_access.indexOf("Payment");
              if (index !== -1) {
                this.user_access.splice(index, 1);
              }
            } else {
              this.chk8 = true;
              this.user_access.push("Payment");
            }
            break;
          case 9:
            if (this.chk9) {
              this.chk9 = false;
              let index = this.user_access.indexOf("Integrations");
              if (index !== -1) {
                this.user_access.splice(index, 1);
              }
            } else {
              this.chk9 = true;
              this.user_access.push("Integrations");
            }
            break;
        }
        this.updateAccess();
      }
    },
    data() {
      return {
        base_url: "",
        page_no: 1,
        support_email:'',
        ldata: null,
        myDt: null,
        user_access: [],
        plans:[],
        chk1: false,
        chk2: false,
        chk3: false,
        chk4: false,
        chk5: false,
        chk6: false,
        chk7: false,
        chk8: false,
        chk9: false,
        busienss_user: '',
        busienss_id: '',
        busienss_name: '',
        busienss_phone: '',
        busienss_address: '',
        busienss_pincode: '',
        busienss_city: '',
        busienss_state: '',
        busienss_country: '',
        busienss_timezone: '',
        msgType: "",
        msgTxt: ""
      };
    },
    created() {
      this.base_url = mainBaseUrl;
      this.getListNow();
      this.busienss_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (sessionStorage.getItem("ldata") && sessionStorage.getItem("ldata").length > 0) {
        this.ldata = JSON.parse(sessionStorage.getItem("ldata"));
        this.busienss_user = this.ldata.user_id;
        this.getMyCall();
       
      }
    },
  }
</script>
<style scoped></style>